import {
  JWT_TOKEN_MANAGEMENT_STATE_TOKEN,
  jwtModuleEmptyState,
} from './state';


export const jwtEmptyStateReset = { [JWT_TOKEN_MANAGEMENT_STATE_TOKEN]: jwtModuleEmptyState };
